var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
function IconRaiting7(props) {
    return (React.createElement("svg", __assign({ width: "35", height: "24", viewBox: "0 0 35 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("circle", { cx: "17", cy: "12", r: "12", fill: "#006742" }),
        React.createElement("circle", { cx: "17", cy: "12", r: "12", stroke: "#B2DFCE" }),
        React.createElement("path", { d: "M14.957 17.7307L18.8808 9.14478H13.6923V7.73657H20.6103V8.83716L16.6865 17.7307H14.957Z", fill: "white" })));
}
export default IconRaiting7;
